export const ACTIONS = require("./actions")
export const ENDPOINTS = require("./endpoints")

export const IS_ACTIVE_INIT_VALUE = 1
export const IS_ACTIVE = "is_active"